var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    opacity: 0.65,
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.943 5.80344L18.9249 20.0368C18.6972 21.0414 18.1034 21.2914 17.2596 20.8182L12.6609 17.4295L10.442 19.5636C10.1964 19.8091 9.99105 20.0145 9.5178 20.0145L9.84819 15.3311L18.3713 7.62949C18.7418 7.29911 18.2909 7.11605 17.7953 7.44644L7.25867 14.081L2.72255 12.6612C1.73585 12.3531 1.718 11.6745 2.92793 11.2012L20.6706 4.36581C21.4921 4.05775 22.2109 4.54886 21.943 5.80344Z",
    fill: "#FFFFFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.8639c2a936126787884dacb6926806c8.svg";
export { ForwardRef as ReactComponent };